module.exports = __webpack_public_path__ + "static/images/bc70ddb86e340b8b28c32319c51dac02.png";